import React, { useState, useEffect } from "react";
import { Card, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import ProfileDetail from "./ProfileDetail";
import EditMedicalRepModal from "./EditMedicalRepModal";
import axios from "axios";
import { baseUrl } from "../../../Baseurl/Baseurl";

// Define the structure of the user and profile object
interface User {
    usertype: number;
    email: string;
    // Add other properties of the user object as needed
}

interface Profile {
    id: string;
    name: string;
    contactno: string;
    user: User;
    // Add other properties of the profile object as needed
}

const UserFirstProfile: React.FC = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [profile, setProfile] = useState<Profile | null>(null); // Use the updated Profile type

    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) throw new Error("Authentication token missing");

                const response = await axios.get(`${baseUrl}login/profile`, {
                    headers: { Authorization: token },
                });

                setProfile(response.data);
            } catch (error) {
                console.error("Error fetching profile:", error);
            }
        };

        fetchProfile();
    }, []);

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    return (
        <>
            <Col sm={12}>
                <Card className="hovercard text-center">
                    <div className="user-image">
                        {profile?.user?.usertype === 1 && (
                            <div className="icon-wrapper" onClick={toggleModal} style={{ cursor: "pointer" }}>
                                <i className="fa-solid fa-pencil step2" />
                            </div>
                        )}
                    </div>
                    {profile && <ProfileDetail profile={profile} />}
                </Card>
            </Col>

            {/* Modal Component */}
            <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Edit Profile</ModalHeader>
                <ModalBody>
                    {profile && <EditMedicalRepModal profile={profile} toggleModal={toggleModal} />}
                </ModalBody>
            </Modal>
        </>
    );
};

export default UserFirstProfile;
